export default {
    //班次
    shiftObj_value: {
        A: {
            value: "A班",
            name: "A班"
        },
        B: {
            value: "B班",
            name: "B班"
        },
        C: {
            value: "C班",
            name: "C班"
        },
        NoDefined: {
            value: "未定义",
            name: "未定义"
        },
    },
	
    shiftObj: {
        A: {
            value: Math.pow(2, 0),
            name: "A班"
        },
        B: {
            value: Math.pow(2, 1),
            name: "B班"
        },
        C: {
            value: Math.pow(2, 2),
            name: "C班"
        },
        NoDefined: {
            value: Math.pow(2, 3),
            name: "未定义"
        },
    },
    // 生产单的状态
    orderStatus: ["准备中", "待生产", "暂停中", "生产中", "已完成"],
    // 角色
    roleArr: ["盘头工", "挡车工", "穿纱工", "机修工", "管理员/厂长", "整经工"],
    roleObj: {
        pantou: {
            value: Math.pow(2, 0),
            name: "盘头工"
        },
        dangche: {
            value: Math.pow(2, 1),
            name: "挡车工"
        },
        chuansha: {
            value: Math.pow(2, 2),
            name: "穿纱工"
        },
        jixiu: {
            value: Math.pow(2, 3),
            name: "机修工"
        },
        admin: {
            value: Math.pow(2, 4),
            name: "管理员/厂长"
        },
        zhengjing: {
            value: Math.pow(2, 5),
            name: "整经工"
        },
    },
    // 打卡记录的数据来源
    dataType: ["机器上传", "人工修改"],
    // 机台预览
    normalState: [1, 2],
    warningState: [0, 3, 4, 8, 9, 10, 11, 12, 13, 14, 15],
    errorState: [5, 6, 7],
    infoState: [-1, 30],
    stateTab: [
        [1, 2],
        [0, 3, 4, 8, 9, 10, 11, 12, 13, 14, 15],
        [5, 6, 7],
        [-1, 30],
    ],
};